import React from 'react';
import { useWhatsNew } from '@components/whatsnew/WhatsNewContext';

interface WhatsNewBadgeProps {
  className?: string;
}

export default function WhatsNewBadge({ className }: WhatsNewBadgeProps) {
  const { unseenCount, isLoading, error } = useWhatsNew();

  if (isLoading || error || unseenCount === 0) {
    return null;
  }

  return (
    <div
      className={`inline-flex items-center justify-center w-5 h-5 bg-destructive text-destructive-foreground text-xs font-semibold rounded-full ${className}`}
      data-testid="whatsnew-badge"
    >
      {unseenCount > 9 ? '9+' : unseenCount}
    </div>
  );
}
